module.exports = __webpack_public_path__ + "img/marker_group_medium.1d7de47d.svg";